import { AutocompleteClient } from './autocompleteClient';

export const createAutocompleteLoader =
  (...urls: string[]) =>
  async (search: string): Promise<string[]> => {
    const results = await Promise.all(urls.map(u => AutocompleteClient.getAutoComplete(u, search)));
    return results.flat();
  };
